import script from "./RcStatusIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcStatusIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./RcStatusIndicator.vue?vue&type=style&index=0&id=67843100&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67843100"]])

export default __exports__